import { API_TRADING_URL, API_TRADING_URL_V2 } from 'constants/api';
import { isRedirectToNewCore } from 'features/securities/utils';

export const getSecuritiesAPIUrl = (): string =>
  isRedirectToNewCore() ? API_TRADING_URL_V2 : API_TRADING_URL;
